"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var AuthHandler = /** @class */ (function () {
    function AuthHandler(tokenHandler) {
        var _this = this;
        this.invalidate = function () {
            _this._tokenHandler.invalidate();
        };
        this._tokenHandler = tokenHandler;
        this.accessToken$ = new rxjs_1.Observable(function (subcriber) {
            tokenHandler.getAccessToken().then(function (accessToken) {
                subcriber.next(accessToken);
            });
        });
        this.decodedToken$ = new rxjs_1.Observable(function (subscriber) {
            tokenHandler.getDecodedToken().then(function (decodedToken) {
                subscriber.next(decodedToken);
            });
        });
        this.permissions$ = new rxjs_1.Observable(function (subscriber) {
            tokenHandler.getPermissions().then(function (permissions) {
                subscriber.next(permissions);
            });
        });
        this.status$ = new rxjs_1.Observable(function (subscriber) {
            tokenHandler.getStatus().then(function (status) {
                subscriber.next(status);
            });
        });
    }
    return AuthHandler;
}());
exports.default = AuthHandler;
//# sourceMappingURL=AuthHandler.js.map